// Registry of all SSE event type names in the system.
// Must stay in sync with sse_event_type_constants.py (backend).
//
// Naming rule: past-tense facts, not commands.
// Group by feature. Add new events here — never hardcode strings in callers.

// payload: { spaceId, spaceName, description, status, teacherName, aiMode, totalEnrolled, classroomIds, classroomNames }
// Full card snapshot — frontend upserts the card (create if absent, update if present).
export const SPACE_CARD_UPDATED = "space_card_updated";

// payload: { spaceId, connectedCount, participants: [{userId, name, role}] }
// Redis-only presence update; fired on every participant join/leave.
export const SPACE_PRESENCE_CHANGED = "space_presence_changed";

// payload: { sessionId, slideIdx }
// One bite is now awaiting analysis. The client flips that tile to Processing in place
// and starts polling the sessions that have one; it does not refetch the grid.
// Carries no status on purpose — see sse_event_type_constants.py for why.
export const ANALYTICS_BITE_UPDATED = "analytics_bite_updated";
